// Copyright (c) Docugami, Inc. All rights reserved.

import { IDocumentCommand } from "components/file_management/DocumentCommand";
import { useState } from 'react';
import { DocsetModelStatsDialog } from "components/reports/DocsetModelStatsDialog";

export function useDocsetModelStatsCommand(docsetId: string, onComplete?: (error?: any) => void): IDocumentCommand {
    const [isActive, setIsActive] = useState(false);

    function getVisual() {
        if (!isActive) {
            return null;
        }

        return (
            <DocsetModelStatsDialog docsetId={docsetId} dismissCallback={() => setIsActive(false)}/>
        )
    }

    return {
        id: "DocsetModelStatsCommand",
        isActive: isActive,
        label: "Accuracy History",
        isEnabled: true,
        visual: getVisual(),
        execute: () => setIsActive(true)
    }
}
